import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';
import { SplashScreen } from '@/components/ui/splash-screen';

const MAX_SPLASH_TIME = 3000;

export function RootRedirect() {
  const { user, isLoading } = useAuth();
  const [showSplash, setShowSplash] = useState(true);
  const [timeoutReached, setTimeoutReached] = useState(false);
  const [isCoach, setIsCoach] = useState<boolean | null>(null);

  useEffect(() => {
    const timeoutTimer = setTimeout(() => {
      setTimeoutReached(true);
    }, MAX_SPLASH_TIME);

    if (!isLoading || timeoutReached) {
      setShowSplash(false);
    }

    return () => clearTimeout(timeoutTimer);
  }, [isLoading, timeoutReached]);

  useEffect(() => {
    if (!user) return;
    // Query coach_profiles — the authoritative source of truth for coach role.
    // user_metadata.primaryRole is not reliable (can be set during test sign-ins and never cleared).
    supabase
      .from('coach_profiles')
      .select('id')
      .eq('user_id', user.id)
      .maybeSingle()
      .then(({ data }) => setIsCoach(!!data));
  }, [user?.id]);

  if (showSplash && isLoading && !timeoutReached) {
    return <SplashScreen />;
  }

  if (user) {
    if (isCoach === true) {
      return <Navigate to="/coach-portal/schedule" replace />;
    }
    // isCoach null (query in-flight) or false → go to /practice
    return <Navigate to="/practice" replace />;
  }

  return <Navigate to="/auth" replace />;
}
